// extracted by css-extract-rspack-plugin
var _1 = "s53j0";
var _2 = "tnAYy";
var _3 = "egJ37";
export { _1 as "sharedContainer", _2 as "sharedIcon", _3 as "sharedText" }
